const profileBanner = {
  "profile.banner.edit-profile": "Edit profile",
  "profile.banner.byb-iq": "BYB IQ",
  "profile.banner.global-rank": "Global Rank",
  "profile.banner.rating": "Rating",
};

const profileLeague = {
  "profile.league.title": "League",
  "profile.league": "{{ name }} League",
  "profile.league.division": "Division {{ name }}",
};

const profileChallenges = {
  "profile.challenges.title": "Challenges",
  "profile.challenges.empty": "You have not completed any challenges yet.",
  "profile.challenges.see.all": "See all",
};

const profileRewards = {
  "profile.rewards.title": "Rewards",
  "profile.rewards.empty": "You have not earned any rewards yet.",
  "profile.rewards.load-error": "Unable to load rewards.",
  "profile.rewards.retry": "Retry",
  "profile.rewards.see.all": "See all",
};

const profileDetails = {
  "profile.details.title": "Details",
  "profile.details.name": "Name",
  "profile.details.first-name": "First Name",
  "profile.details.last-name": "Last Name",
  "profile.details.email": "Email",
  "profile.details.gender": "Gender",
  "profile.details.phone": "Phone",
  "profile.details.country": "Country",
  "profile.details.city": "City",
  "profile.details.address": "Address",
  "profile.details.postal-code": "Postal Code",
  "profile.details.birthday": "Birthday",
  "profile.details.years-old": " years old",
  "profile.details.member-since": "Member since",
};

const profileMenu = {
  "profile.menu.alt": "Profile",
  "profile.menu.my-account": "My Account",
  "profile.menu.switch-profile": "Switch Profile",
  "profile.menu.switch-account": "Switch Account",
  "profile.menu.sign-out": "Sign Out",
};

const profilePageMobile = {
  "profile.page.mobile.title": "Profile Settings",
  "profile.page.mobile.save": "Save Changes",
};

const profileImageUploader = {
  "profile.image-uploader.new-avatar": "New avatar",
  "profile.image-uploader.delete-avatar": "Delete avatar",
  "profile.image-uploader.upload.no-image": "Please select an image first.",
  "profile.image-uploader.upload.error": "Something went wrong. Please try again.",
  "profile.image-uploader.upload.success": "Image uploaded and processed successfully!",
  "profile.image-uploader.upload.failed": "Failed to upload and process image. Please ensure it is appropriate.",
};

const profileTrophyRoom = {
  "profile.trophy-room.title": "Trophy Room",
  "profile.trophy-room.subtitle": "Your earned rewards",
  "profile.trophy-room.empty": "You have not earned any rewards yet.",
  "profile.trophy-room.see.all": "See all",
  "profile.trophy-room.rewards.label": "Rewards",
  "profile.trophy-room.rewards.count": "{{ count }} rewards",
};

const profileSettings = {
  "profile.settings.first.name": "First name",
  "profile.settings.last.name": "Last name",
  "profile.settings.email": "Email address",
  "profile.settings.dob": "Date of birth",
  "profile.settings.gender": "Gender",
  "profile.settings.gender.na": "N/A",
  "profile.settings.gender.male": "Male",
  "profile.settings.gender.female": "Female",
  "profile.settings.button.saving": "Saving...",
  "profile.settings.button.save": "Save Changes",
  "profile.settings.validation.first.name": "You must enter a first name",
  "profile.settings.validation.last.name": "You must enter a last name",
  "profile.settings.validation.country.code": "Country code must be 2 letters",
  "profile.settings.country-code.placeholder": "e.g. PT",
  "profile.settings.country.none": "None",
  "profile.settings.completion": "{{percentage}}% profile completion",
};

export const profile = {
  ...profileBanner,
  ...profileLeague,
  ...profileChallenges,
  ...profileRewards,
  ...profileDetails,
  ...profileMenu,
  ...profilePageMobile,
  ...profileImageUploader,
  ...profileTrophyRoom,
  ...profileSettings,
};
